module.exports = __webpack_public_path__ + "static/media/prapti.19bcfd90.jpeg";